export var ContractAutoGeneratedType;
(function (ContractAutoGeneratedType) {
    ContractAutoGeneratedType[ContractAutoGeneratedType["SECONDMENTAGREEMENTFIXEDTIMEPHASEB"] = 1] = "SECONDMENTAGREEMENTFIXEDTIMEPHASEB";
    ContractAutoGeneratedType[ContractAutoGeneratedType["DETACHERINGSOVEREENKOMSTONBEPAALDETIJDFASEC"] = 2] = "DETACHERINGSOVEREENKOMSTONBEPAALDETIJDFASEC";
    ContractAutoGeneratedType[ContractAutoGeneratedType["UITZENDOVEREENKOMSTBEPAALDETIJDFASEA"] = 3] = "UITZENDOVEREENKOMSTBEPAALDETIJDFASEA";
    ContractAutoGeneratedType[ContractAutoGeneratedType["SECONDMENTAGREEMENTFIXEDTIMEPHASEBEN"] = 4] = "SECONDMENTAGREEMENTFIXEDTIMEPHASEBEN";
    ContractAutoGeneratedType[ContractAutoGeneratedType["AGENCYWORKEMPLOYMENTFIXEDTIMEPHASEAEN"] = 5] = "AGENCYWORKEMPLOYMENTFIXEDTIMEPHASEAEN";
    ContractAutoGeneratedType[ContractAutoGeneratedType["SECONDMENTAGREEMENTINDEFINITEPERIODPHASECEN"] = 6] = "SECONDMENTAGREEMENTINDEFINITEPERIODPHASECEN";
    ContractAutoGeneratedType[ContractAutoGeneratedType["AGENCYWORKEMPLOYMENTFIXEDTIMEPHASEANL"] = 7] = "AGENCYWORKEMPLOYMENTFIXEDTIMEPHASEANL";
    ContractAutoGeneratedType[ContractAutoGeneratedType["DETACHERINGSOVEREENKOMSTBEPAALDETIJDFASEB"] = 8] = "DETACHERINGSOVEREENKOMSTBEPAALDETIJDFASEB";
    ContractAutoGeneratedType[ContractAutoGeneratedType["DETACHERINGSOVEREENKOMSTONBEPAALDETIJDFASECNL"] = 9] = "DETACHERINGSOVEREENKOMSTONBEPAALDETIJDFASECNL";
})(ContractAutoGeneratedType || (ContractAutoGeneratedType = {}));
export const ContractAutoGeneratedTypeOptions = [
    // { label: 'Secondment Agreement Fixed Time Phase B (ENG)', value: ContractAutoGeneratedType.SECONDMENTAGREEMENTFIXEDTIMEPHASEB },
    // {
    //     label: 'Secondment Agreement for an Indefinite Period – Phase C (NL)',
    //     value: ContractAutoGeneratedType.DETACHERINGSOVEREENKOMSTONBEPAALDETIJDFASEC
    // },
    // { label: 'Temporary Employment Agreement Phase A (NL)', value: ContractAutoGeneratedType.UITZENDOVEREENKOMSTBEPAALDETIJDFASEA },
    { label: 'Secondment Agreement Fixed Time Phase B (EN)', value: ContractAutoGeneratedType.SECONDMENTAGREEMENTFIXEDTIMEPHASEBEN },
    { label: 'Agency Work Employment Fixed Time Phase A (EN)', value: ContractAutoGeneratedType.AGENCYWORKEMPLOYMENTFIXEDTIMEPHASEAEN },
    {
        label: 'Secondment Agreement Indefinite Period Phase C (EN)',
        value: ContractAutoGeneratedType.SECONDMENTAGREEMENTINDEFINITEPERIODPHASECEN
    },
    { label: 'Agency Work Employment Fixed Time Phase A (NL)', value: ContractAutoGeneratedType.AGENCYWORKEMPLOYMENTFIXEDTIMEPHASEANL },
    {
        label: 'Detacheringsovereenkomst Bepaalde Tijd Fase B (NL)',
        value: ContractAutoGeneratedType.DETACHERINGSOVEREENKOMSTBEPAALDETIJDFASEB
    },
    {
        label: 'Detacheringsovereenkomst Onbepaalde Tijd Fase C (NL)',
        value: ContractAutoGeneratedType.DETACHERINGSOVEREENKOMSTONBEPAALDETIJDFASECNL
    }
];
// Legacy options for old records only — do not show for new contracts
export const ContractAutoGeneratedTypeLegacyOptions = [
    { label: 'Secondment Agreement Fixed Time Phase B (ENG)', value: ContractAutoGeneratedType.SECONDMENTAGREEMENTFIXEDTIMEPHASEB },
    {
        label: 'Secondment Agreement for an Indefinite Period – Phase C (NL)',
        value: ContractAutoGeneratedType.DETACHERINGSOVEREENKOMSTONBEPAALDETIJDFASEC
    },
    { label: 'Temporary Employment Agreement Phase A (NL)', value: ContractAutoGeneratedType.UITZENDOVEREENKOMSTBEPAALDETIJDFASEA }
];
